export function uriEncode(array){
	return encodeURIComponent(JSON.stringify(array));
}